import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

import Api from "../Api/Api.json";

const fetchComplaints = async (id) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.PATIENT_API;
  const requestData = {
    task: "getChiefComplaintList",
    patient_id: id,
  };
  const response = await axios.post(url, requestData, headers);
  if (!response.data) {
    throw new Error("Failed to fetch chief complaints");
  }
  console.log("📡 Fetched complaints for:", id);
  console.log("📦 Complaints response data:", response.data);
  return response.data;
};

const editComplaints = async (data) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.PATIENT_API;
  const requestData = {
    task: "editChiefComplaintListItem",
    date: data.date,
    updatedText: data.text,
    patient_id: data.id,
  };
  const response = await axios.post(url, requestData, headers);
  if (!response.data) {
    throw new Error("Failed to edit chief complaints");
  }
  return response.data;
}

export const useChiefComplaintsData = (id) => {
  return useQuery({
    queryKey: ["chiefComplaintsData", id],
    queryFn: () => fetchComplaints(id),
    enabled: !!id,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
  });
};

export const useEditComplaintsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editComplaints,
    onSuccess: (data, variables) => {
      // Invalidate and refetch the complaints for the updated patient
      queryClient.invalidateQueries(["chiefComplaintsData", variables.id]);
    },
  });
};